export default "__VITE_ASSET__BDSqQ9ZV__"